import { z } from 'zod/v4';
import { companySchema } from './company.js';

/**
 * Sort columns the admin company-network endpoint accepts. Each key maps to
 * a `companies_view`/`companies_removed_view` column in `SORT_COLUMNS` of
 * `core/db/companies/list-admin-network.ts` — keep the two in sync when
 * adding/removing columns.
 */
export const AdminCompaniesNetworkSortColumns = [
  'name',
  'country',
  'updatedAt',
  'facilityProcesses',
  'city',
  'createdAt',
  'officialName',
  'isDemoCompany',
] as const;

export type AdminCompaniesNetworkSortColumn =
  (typeof AdminCompaniesNetworkSortColumns)[number];

const sortParamSchema = z
  .string()
  .regex(/^[a-zA-Z]+:(ASC|DESC|asc|desc)$/)
  .optional();

const booleanLike = z
  .union([z.boolean(), z.string()])
  .optional()
  .transform(v => v === true || v === 'true');

export const AdminCompaniesNetworkParamsSchema = z.object({
  id: z.string().min(1, 'Company ID is required'),
});

export type AdminCompaniesNetworkParams = z.infer<
  typeof AdminCompaniesNetworkParamsSchema
>;

export const AdminCompaniesNetworkQuerySchema = z.object({
  page: z.coerce.number().int().min(0).default(0),
  count: z.coerce.number().int().min(0).max(500).default(15),
  sort: sortParamSchema,
  /** true = the given company's network among soft-removed companies. */
  removed: booleanLike,
});

export type AdminCompaniesNetworkQuery = z.infer<
  typeof AdminCompaniesNetworkQuerySchema
>;

export const AdminCompaniesNetworkResponseSchema = z.array(companySchema);

export type AdminCompaniesNetworkResponse = z.infer<
  typeof AdminCompaniesNetworkResponseSchema
>;
